import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

import { tokens } from '../../../../tokens';

export enum SecondaryColumnVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const secondaryColumnVariants: Variants = {
    [SecondaryColumnVariant.Hidden]: {
        opacity: 0,
        // Would be ideal to find an alternative to animating `margin`.
        marginRight: `-${tokens.layout.secondary.width}px`,
    },
    [SecondaryColumnVariant.Show]: {
        opacity: 1,
        marginRight: 0,
    },
};

export const secondaryColumnTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.4,
};
